<template>
  <div class="flex flex-row items-center gap-2">
    <label @click="openVerify" class="flex items-center cursor-pointer gap-2">
      {{ fullPhone }}
      <div v-if="phoneLoaded">
        <SvgContainer v-if="verfied" name="phoneVerified" />
        <SvgContainer v-else name="phoneNotVerified" />
      </div>
      <SvgContainer name="pencilProfile" />
    </label>
    <VerifyAndAddPhone v-if="verify"
      :initialPhone="phone!"
      :initialPrefix="prefix!"
      :hasPhone="hasPhone"
      :showRemain="false"
      :open="showPhonePopup"
      @close="showPhonePopup = false"
      @newPhone="handleNewPhone"
    />
   </div>
 </template>
<script lang="ts">
  import CustomerHelper from "@/helpers/customerHelper";
  import SvgContainer from "@/views/SvgContainer.vue";
  import { Customer, CustomerPhone } from "models";
  import { defineComponent } from "vue";
  import VerifyAndAddPhone from "@/components/form/verifyAndAddPhone.vue";
  
  export default defineComponent({
    name: "ProfileNickName",
    data() {
      return {
        showPhonePopup: false as boolean,
        phone: "" as undefined | null |string,
        prefix: "" as undefined | null |string,
        fullPhone: "" as string,
        verfied: false as undefined | null | boolean,
        hasPhone: false,
        phoneLoaded: false,
        verify: true
      };
    },
    components: {
      SvgContainer,
      VerifyAndAddPhone
    },
    async created(){
      const response: Customer = await CustomerHelper.getCustomer() as Customer;
      if(response.phone){
        this.hasPhone = true;
        const phone: CustomerPhone = response.phone
        this.phone = phone.value
        this.prefix = phone.prefix
        this.fullPhone = this.setFullPhone(this.prefix!, this.phone!)
        this.verfied = phone.verified
      }
      this.phoneLoaded = true
    },
    methods: {
      setFullPhone(prefix: string, value:string){
        return `+${prefix} ${value}`
      },
      handleNewPhone(prefix: string, value: string){
        this.prefix = prefix
        this.phone = value
        this.fullPhone = this.setFullPhone(prefix, value)
        this.verfied = false
      },
      openVerify(){
        this.verify = true
        this.showPhonePopup = true
      }
    },
  });
</script>
  
<style scoped>
  .input {
    background-color: black;
    color: white;
  }
</style>
  